export default __webpack_public_path__ + "0a46f87771a75aa4dd16008f4840cd1e.png";